export enum AuthenticationClaimType {
  Invalid = 0,
  LocalToken = 1,
  WiseTechGlobalSupportToken = 2,
  LocalIdentityToken = 3,
}
